const subEventProgressHeadingId = (subEventId: string): string =>
  `sub-event-progress-heading-${subEventId}`;

const scrollToSubEventProgressSection = (subEventId: string): void => {
  document.getElementById(subEventProgressHeadingId(subEventId))?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
};

export { subEventProgressHeadingId };
export default scrollToSubEventProgressSection;
